import { render, staticRenderFns } from "./ViewerCharsetPart.vue?vue&type=template&id=56bfb848&scoped=true"
import script from "./ViewerCharsetPart.vue?vue&type=script&lang=js"
export * from "./ViewerCharsetPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bfb848",
  null
  
)

export default component.exports